import Head from 'next/head'

interface SeoHeadProps {
  title: string
  description?: string
  type?: string
  url?: string
  image?: string
  canonicalLink?: string
  author?: string
  noIndex?: boolean
  social?: {
    url?: string
    title?: string
    description?: string
    image?: string
    creator?: string
  }
  children?: React.ReactNode
}

export const SeoHead = ({ children, ...props }: SeoHeadProps): React.ReactElement => {
  return (
    <Head>
      <meta httpEquiv="Cache-Control" content="no-cache" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/projects/favicons/favicon.png" />
      {props.title && (
        <>
          <title>{props.title}</title>
          <meta name="title" content={props.title} />
          <meta property="og:title" content={props.title} />
        </>
      )}
      {props.description && (
        <>
          <meta name="description" content={props.description} />
          <meta property="og:description" content={props.description} />
        </>
      )}
      {props.url && <meta property="og:url" content={props.url} />}
      {props.image && <meta property="og:image" content={props.image} />}
      {props.type ? <meta property="og:type" content={props.type} /> : <meta property="og:type" content="article" />}
      {props.author ? <meta name="author" content={props.author} /> : <meta name="author" content="SimScale" />}
      {props.canonicalLink && <link rel="canonical" href={props.canonicalLink} />}
      {props.social && (
        <>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@SimScale" />
          {props.social.url ? (
            <meta property="twitter:url" content={props.social.url} />
          ) : (
            <meta property="twitter:url" content={props.url} />
          )}
          {props.social.title ? (
            <meta property="twitter:title" content={props.social.title} />
          ) : (
            <meta property="twitter:title" content={props.title} />
          )}
          {props.social.description ? (
            <meta property="twitter:description" content={props.social.description} />
          ) : (
            <meta property="twitter:description" content={props.description} />
          )}
          {props.social.image ? (
            <meta property="twitter:image" content={props.social.image} />
          ) : (
            <meta property="twitter:image" content={props.image} />
          )}
          {props.social.creator ? (
            <meta property="twitter:creator" content={props.social.creator} />
          ) : (
            <meta property="twitter:creator" content={props.author} />
          )}
        </>
      )}
      {props.noIndex && <meta name="robots" content="noindex" />}
      {children}
    </Head>
  )
}
